import JSZip from "jszip";
import { toast } from "react-toastify";

export const downloadFilesAsZip = async (signedUrls, zipFileName) => {
  if (!signedUrls || signedUrls.length === 0) {
    toast.error("No files found to download");
    throw new Error("No files to download");
  }

  try {
    const zip = new JSZip();

    const downloadPromises = signedUrls.map(async ({ url, key }) => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to download ${key}`);
        }
        const blob = await response.blob();
        const filename = key.split('/').pop();
        zip.file(filename, blob);
      } catch (error) {
        console.error(`Error downloading ${key}:`, error);
        throw error;
      }
    });

    await Promise.all(downloadPromises);

    const zipBlob = await zip.generateAsync({ type: "blob" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(zipBlob);
    link.download = `${zipFileName}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

  } catch (error) {
    console.error("Error creating ZIP file:", error);
    throw error;
  }
};
